var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock1Month(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_5723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9002 23.5995C10.9002 23.7995 3.60023 26.5995 3.70023 29.8995C3.80023 33.1995 11.2002 35.5995 20.2002 35.3995C29.2002 35.1995 36.5002 32.3995 36.4002 29.0995C36.3002 25.7995 28.9002 23.3995 19.9002 23.5995Z",
    fill: "url(#paint0_linear_641_5723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1453 35.3977C29.2 35.1764 36.4758 32.3563 36.3962 29.0988C36.3166 25.8413 28.9117 23.38 19.857 23.6013C10.8022 23.8226 3.52645 26.6427 3.60606 29.9002C3.68568 33.1577 11.0905 35.619 20.1453 35.3977Z",
    stroke: "url(#paint1_linear_641_5723)",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 26.8999C26.3996 26.6999 31.7996 28.4999 31.7996 30.8999C31.8996 33.1999 26.5996 35.2999 20.0996 35.3999C13.5996 35.4999 8.19963 33.7999 8.19963 31.3999C8.09963 29.0999 13.3996 26.9999 19.8996 26.8999Z",
    fill: "url(#paint2_linear_641_5723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1023 35.3006C26.6173 35.1414 31.8528 33.1324 31.7961 30.8135C31.7394 28.4946 26.4121 26.7439 19.897 26.9031C13.382 27.0623 8.14653 29.0712 8.2032 31.3901C8.25987 33.709 13.5873 35.4598 20.1023 35.3006Z",
    stroke: "url(#paint3_linear_641_5723)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 0.5V35.3",
    stroke: "url(#paint4_linear_641_5723)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9004 0.5V35.3",
    stroke: "url(#paint5_linear_641_5723)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 26.2996C27.1405 26.2996 29.2 24.2401 29.2 21.6996C29.2 19.1591 27.1405 17.0996 24.6 17.0996C22.0595 17.0996 20 19.1591 20 21.6996C20 24.2401 22.0595 26.2996 24.6 26.2996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 26.2996C27.1405 26.2996 29.2 24.2401 29.2 21.6996C29.2 19.1591 27.1405 17.0996 24.6 17.0996C22.0595 17.0996 20 19.1591 20 21.6996C20 24.2401 22.0595 26.2996 24.6 26.2996Z",
    stroke: "url(#paint6_linear_641_5723)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6004 25.4C26.6438 25.4 28.3004 23.7435 28.3004 21.7C28.3004 19.6565 26.6438 18 24.6004 18C22.5569 18 20.9004 19.6565 20.9004 21.7C20.9004 23.7435 22.5569 25.4 24.6004 25.4Z",
    stroke: "url(#paint7_linear_641_5723)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6004 25.4C26.6438 25.4 28.3004 23.7435 28.3004 21.7C28.3004 19.6565 26.6438 18 24.6004 18C22.5569 18 20.9004 19.6565 20.9004 21.7C20.9004 23.7435 22.5569 25.4 24.6004 25.4Z",
    fill: "url(#paint8_linear_641_5723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1996 14.3992C15.7401 14.3992 17.7996 12.3397 17.7996 9.79922C17.7996 7.25871 15.7401 5.19922 13.1996 5.19922C10.6591 5.19922 8.59961 7.25871 8.59961 9.79922C8.59961 12.3397 10.6591 14.3992 13.1996 14.3992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1996 14.3992C15.7401 14.3992 17.7996 12.3397 17.7996 9.79922C17.7996 7.25871 15.7401 5.19922 13.1996 5.19922C10.6591 5.19922 8.59961 7.25871 8.59961 9.79922C8.59961 12.3397 10.6591 14.3992 13.1996 14.3992Z",
    stroke: "url(#paint9_linear_641_5723)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 13.4996C15.2435 13.4996 16.9 11.8431 16.9 9.79961C16.9 7.75616 15.2435 6.09961 13.2 6.09961C11.1565 6.09961 9.5 7.75616 9.5 9.79961C9.5 11.8431 11.1565 13.4996 13.2 13.4996Z",
    stroke: "url(#paint10_linear_641_5723)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 13.4996C15.2435 13.4996 16.9 11.8431 16.9 9.79961C16.9 7.75616 15.2435 6.09961 13.2 6.09961C11.1565 6.09961 9.5 7.75616 9.5 9.79961C9.5 11.8431 11.1565 13.4996 13.2 13.4996Z",
    fill: "url(#paint11_linear_641_5723)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_5723",
    x1: 20.0002,
    y1: 28.3199,
    x2: 20.0002,
    y2: 39.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8811,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_641_5723",
    x1: 19.6899,
    y1: 23.3105,
    x2: 20.2922,
    y2: 35.6257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_641_5723",
    x1: 20.0012,
    y1: 29.8922,
    x2: 20.0012,
    y2: 38.4022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_641_5723",
    x1: 19.8193,
    y1: 26.7882,
    x2: 20.2433,
    y2: 35.4577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C2460C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#953609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6D2707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4B1B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#301103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#1B0A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0C0401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#030100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_641_5723",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA490C",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7C2D07",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_641_5723",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA490C",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7C2D07",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_641_5723",
    x1: 24.0304,
    y1: 26.7933,
    x2: 25.294,
    y2: 17.1754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_641_5723",
    x1: 21.8809,
    y1: 23.7398,
    x2: 27.8499,
    y2: 19.1648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_641_5723",
    x1: 24.6992,
    y1: 20.5037,
    x2: 24.7817,
    y2: 17.1412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_641_5723",
    x1: 12.6703,
    y1: 14.9631,
    x2: 13.9341,
    y2: 5.34532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_641_5723",
    x1: 10.521,
    y1: 11.908,
    x2: 16.4905,
    y2: 7.33394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_641_5723",
    x1: 13.3391,
    y1: 8.6691,
    x2: 13.4213,
    y2: 5.30629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_5723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock1Month);
export default __webpack_public_path__ + "static/media/lock-1-month.f71fb056815566867635bd1ce2e1cc19.svg";
export { ForwardRef as ReactComponent };